import { createBrowserRouter } from "react-router-dom";

import { AppShell } from "@/app/layout/AppShell";
import { RequireAuth } from "@/app/layout/RequireAuth";
import { AuditPage } from "@/features/audit/AuditPage";
import { LoginPage } from "@/features/auth/LoginPage";
import { DashboardPage } from "@/features/dashboard/DashboardPage";
import { DevicesPage } from "@/features/devices/DevicesPage";
import { GrafanaPage } from "@/features/grafana/GrafanaPage";
import { LogsPage } from "@/features/logs/LogsPage";
import { NasPage } from "@/features/nas/NasPage";
import { ReportsPage } from "@/features/reports/ReportsPage";
import { SessionsPage } from "@/features/sessions/SessionsPage";
import { SettingsPage } from "@/features/settings/SettingsPage";
import { UsersPage } from "@/features/users/UsersPage";

export const router = createBrowserRouter([
  { path: "/login", element: <LoginPage /> },
  {
    element: <RequireAuth />,
    children: [
      {
        element: <AppShell />,
        children: [
          { path: "/", element: <DashboardPage /> },
          { path: "/dashboard", element: <DashboardPage /> },
          { path: "/users", element: <UsersPage /> },
          { path: "/sessions", element: <SessionsPage /> },
          { path: "/devices", element: <DevicesPage /> },
          { path: "/nas", element: <NasPage /> },
          { path: "/reports", element: <ReportsPage /> },
          { path: "/logs", element: <LogsPage /> },
          { path: "/settings", element: <SettingsPage /> },
          { path: "/grafana", element: <GrafanaPage /> },
          { path: "/audit", element: <AuditPage /> },
        ],
      },
    ],
  },
]);
